import { SideBetResult } from './api-dto';
import { SideBetPrediction } from './constants';

export type SideBetScore = {
  winners: string[];
  losers: string[];
};

export type SideBetTally = {
  believe: number;
  doubt: number;
  undecided: number;
};

/**
 * Split side bets into winners (predicted the outcome) and losers.
 * `wasCorrect` is whether the active player got the move right.
 */
export const scoreSideBets = (
  bets: Pick<SideBetResult, 'bettorGuid' | 'prediction'>[],
  wasCorrect: boolean
): SideBetScore => {
  const winners: string[] = [];
  const losers: string[] = [];
  for (const bet of bets) {
    const predictedCorrect = bet.prediction === SideBetPrediction.CORRECT;
    if (predictedCorrect === wasCorrect) {
      winners.push(bet.bettorGuid);
    } else {
      losers.push(bet.bettorGuid);
    }
  }
  return { winners, losers };
};

/**
 * Live tally of nails-it vs whiffs vs players who have not bet yet.
 * `benchCount` is everyone eligible to bet (all players except the one up).
 */
export const tallySideBets = (
  bets: Pick<SideBetResult, 'prediction'>[],
  benchCount: number
): SideBetTally => {
  let believe = 0;
  let doubt = 0;
  for (const bet of bets) {
    if (bet.prediction === SideBetPrediction.CORRECT) {
      believe += 1;
    } else {
      doubt += 1;
    }
  }
  return {
    believe,
    doubt,
    undecided: Math.max(0, benchCount - bets.length),
  };
};
